module.exports = __webpack_public_path__ + "static/media/pdx-floor-5.aecabeb7.png";